import { render } from "./filing-count.vue?vue&type=template&id=08ece918&scoped=true"
import script from "./filing-count.vue?vue&type=script&lang=js"
export * from "./filing-count.vue?vue&type=script&lang=js"

import "./filing-count.vue?vue&type=style&index=0&id=08ece918&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ece918"]])

export default __exports__